<script>
  import { useLocation } from 'svelte-navigator';
  import { get } from 'svelte/store';
  import {
    currentLocation,
    pathTrappe,
    alertReload,
    sketchfabId,
    linkPdfId,
    idTrappe,
    nomTrappe,
    choix,
    dimLongueur,
    dimLargeur,
    sensOuverture,
    fermeture,
    type,
    couleur,
    epaisseur,
    dureeResistance,
    dimLongueurIdFiche,
    dimLargeurIdFiche,
    sensOuvertureIdFiche,
    fermetureIdFiche,
    typeIdFiche,
    couleurIdFiche,
    epaisseurIdFiche,
    dureeResistanceIdFiche,
    coupeFeuIdPath,
    quantite,
    commentaire,
  } from '../stores.js';

  // const location = useLocation();
  // $currentLocation = $location.pathname;
  // console.log(`))))))))------ in Paths.svelte : ${$currentLocation}`);
  let trappePath = [];
  let trappePathName = [];

  // trappePath['/LayoutPage/1'] = 'ffff';
  // trappePath['/LayoutPage/2'] = 'ggggg';
  // console.log(trappePath);

  export let namestore;
  // export let idstore;

  // function buildPaths(loc, tPath, name, tPathName) {
  //   if (loc == '/LayoutPage') {
  //     tPath = [];
  //     tPathName = [];
  //   } else {
  //     const index = tPath.indexOf(loc);
  //     if (index !== -1) {
  //       // Delete only if not the current page
  //       if (index !== tPath.length - 1) {
  //         tPath.splice(index + 1);
  //         tPathName.splice(index + 1);
  //       }
  //     } else {
  //       tPath = [...tPath, loc];
  //       // trappePathName[0] = 'nomTrappe';
  //       // let nstore = get(eval(trappePathName[0]));
  //       let nstore = get(name);
  //       tPathName = [...tPathName, nstore];
  //       // if (name != null) {
  //       //   console.log(`name is not null : ${name}`);
  //       //   tPathName = [...tPathName, name];
  //       // } else {
  //       //   console.log(`name IS null : ${name}`);
  //       // }
  //       // if (name != null)
  //     }
  //   }

  //   return [tPath, tPathName];
  // }

  function buildPaths(loc, tPath) {
    if (loc == '/LayoutPage') {
      tPath = [];
    } else {
      const index = tPath.indexOf(loc);
      if (index !== -1) {
        // Delete only if not the current page
        if (index !== tPath.length - 1) {
          tPath.splice(index + 1);
        }
      } else {
        tPath = [...tPath, loc];
      }
    }
    return tPath;
  }

  function buildPathsName(name, tPathName) {
    // if (name != null) {
    if (typeof name !== 'undefined') {
      // let nstore = get(eval(name));
      let nstore = eval(name);
      tPathName = [...tPathName, nstore];
    }
    return tPathName;
  }

  $: {
    // console.log(`________Paths.svelte________`);

    // pathTrail.add($location.pathname);
    // console.log($pathTrail);

    // console.log(`((((((((((((((((((( $location ${$location}`);
    // console.log($location.pathname);
    // trappePath = [...trappePath, $location.pathname];
    // console.log(`))))))))))))))))))))))))))) trappePath ${trappePath}`);
    // console.log(trappePath);
    // let a, b;
    // [a, b] = trappePath = buildPaths(
    //   $location.pathname,
    //   trappePath,
    //   namestore,
    //   trappePathName
    // );
    // console.log(a);
    // console.log(b);

    // console.log($location.pathname);

    // trappePath = buildPaths($location.pathname, trappePath);
    // console.log(trappePath);

    // trappePathName = buildPathsName(namestore, trappePathName);
    // if (typeof namestore !== 'undefined') {
    //   console.log(`namestore is defined`);
    //   // let nstore = get(eval(name));
    //   // let nstore = eval(namestore);
    //   console.log(`namestore : ${namestore}`);
    //   console.log(eval(namestore));
    //   console.log(get(eval(namestore)));
    //   // trappePathName = [...trappePathName, nstore];
    // }

    // console.log(trappePath);
    // console.log(trappePathName);

    // trappePathName[0] = 'nomTrappe';
    // let nstore = get(eval(trappePathName[0]));
    // console.log(nstore);

    // console.log($location.pathname);
    // console.log(`____________________________`);

    setTimeout(() => {
      // alert('Paths.svelte');

      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }, '250');
  }
</script>
